import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/500.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/manrope/300.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import ForStartupsPage from "@/pages/ForStartupsPage";
import ForTalentPage from "@/pages/ForTalentPage";
import AssociatePartnerProgramPage from "@/pages/AssociatePartnerProgramPage";
import JobsPage from "@/pages/JobsPage";
import JobDetailPage from "@/pages/JobDetailPage";
import AboutPage from "@/pages/AboutPage";
import InsightsPage from "@/pages/InsightsPage";
import ArticlePage from "@/pages/ArticlePage";
import ContactPage from "@/pages/ContactPage";
import CompanyInfoPage from "@/pages/CompanyInfoPage";
import ToolsPage from "@/pages/ToolsPage";
import OverviewPage from "@/pages/OverviewPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ContractorPortal from "@/pages/ContractorPortal";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import TestimonialSubmitPage from "@/pages/TestimonialSubmitPage";
import PayInvoicePage from "@/pages/PayInvoicePage";
import VerifyPage from "@/pages/VerifyPage";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

// Layout wrapper that conditionally shows nav/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isPortalRoute = location.pathname.startsWith('/portal');
  const isPayRoute = location.pathname.startsWith('/pay');
  const isVerifyRoute = location.pathname.startsWith('/verify');
  const hideChrome = isAdminRoute || isPayRoute || isPortalRoute || isVerifyRoute;
  
  return (
    <>
      {!hideChrome && <Navigation />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
      {!hideChrome && <ChatWidget />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/for-startups" element={<ForStartupsPage />} />
              <Route path="/for-talent" element={<ForTalentPage />} />
              <Route path="/associate-partner-programme" element={<AssociatePartnerProgramPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/jobs/:jobId" element={<JobDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/insights/:slug" element={<ArticlePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/tools" element={<ToolsPage />} />
              <Route path="/overview" element={<OverviewPage />} />
              <Route path="/company-info" element={<CompanyInfoPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiePolicyPage />} />
              <Route path="/testimonial/submit" element={<TestimonialSubmitPage />} />
              <Route path="/share/:memberId" element={<TestimonialSubmitPage />} />
              <Route path="/pay/:invoiceNumber" element={<PayInvoicePage />} />
              <Route path="/verify/:memberId" element={<VerifyPage />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/portal" element={<ContractorPortal />} />
            </Routes>
          </Layout>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
